
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";
import { AnexoProps } from "../comun/AnexoInterface";
import { PaginacionProps } from "../global/PaginacionInterface";
import { NotificacionesProps } from "../notificaciones/NotificacionesInterface";
import { defaultExpediente, ExpedienteProps } from "../recepcion/ExpedienteInterface";
import { defaultFechaAudiencia, FechaAudienciaProps } from "./AgendaInterface";

// Definición de defaults

export const defaultAudiencia: AudienciaProps = {
    idAudiencia:                0,
    asignadoMismoUsuario:       false,
    seCelebro:                  false,
    generarConvenio:            false,
    seDifiere:                  false,
    idTipoCausaDiferimiento:    0,
    tipoCausaDiferimiento:      '',
    idTipoConvenio:             0,
    tipoConvenio:               '',
    idTipoNoCelebracion:        0,
    tipoNoCelebracion:          '',
    idTipoAudiencia:            0,
    tipoAudiencia:              '',
    idPlantilla:                0,
    plantilla:                  '',
    idEstatus:                  0,
    estatus:                    '',
    documento:                  '',
    contenido:                  '',
    usuarioAsignado:            '',
    juez:                       '',
    secretario:                 '',
    motivoDiferimiento:         '',
    idExpediente:               0,
    expediente:                 defaultExpediente,
    citaSentencia:              false,
    habilitarCitacionSentencia: false,
    fechaAudiencia:             defaultFechaAudiencia,
    solicitarFechaAudiencia:    false,
    observaciones:              false,
    idUsuarioElaboro:           0,
    asistentes:                 [],
    notificaciones:             [],
    anexos:                     [],
    promociones:                [],
    usuarioObservaciones:       [],
}

export const defaultAsistente: AsistenteProps = {
    id:                     0,
    idTipoParte:            0,
    tipoParte:              '',
    idPersona:              0,
    persona:                '',
    idTipoIdentificacion:   0,
    tipoIdentificacion:     '',
    notificado:             false,
    asistio:                false,
    cedulaNotificacion:     '',
    razonamiento:           '',
    idTipoPersona:          0,
}


export const defaultObtenerAgendaAudienciasResponse: ObtenerAgendaAudienciasResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultCelebrarAudiencia: CelebrarAudienciaResponse = {
    ...defaultHttpResponse,
    idAudiencia: '',
}

export const defaultAudienciaDetalle: AudienciaDetalleResponse = {
    ...defaultHttpResponse,
    ...defaultAudiencia,
}

export const defaultActualizarEstatusAudiencia: ActualizarEstatusAudienciaResponse = {
    ...defaultHttpResponse,
    asignadoMismoUsuario:   false,
    usuarioAsignado:        '',
}

// Creación de interface

export interface CelebrarAudienciaParams {
    idAgenda:       number;
    idJuez:         number;
    idSecretario:   number;
}

export interface CelebrarAudienciaResponse extends HttpResponse {
    idAudiencia: string;
}

export interface AudienciaProps {
    idAudiencia:                number;
    asignadoMismoUsuario:       boolean;
    seCelebro:                  boolean;
    generarConvenio:            boolean;
    seDifiere:                  boolean;
    idTipoCausaDiferimiento:    number;
    tipoCausaDiferimiento:      string;
    idTipoConvenio:             number;
    tipoConvenio:               string;
    idTipoNoCelebracion:        number;
    tipoNoCelebracion:          string;
    idTipoAudiencia:            number;
    tipoAudiencia:              string;
    idPlantilla:                number;
    plantilla:                  string;
    idEstatus:                  number;
    estatus:                    string;
    contenido:                  string;
    documento:                  string;
    usuarioAsignado:            string;
    juez:                       string;
    secretario:                 string;
    motivoDiferimiento:         string;
    idExpediente:               number;
    expediente:                 ExpedienteProps;
    citaSentencia:              boolean;
    habilitarCitacionSentencia: boolean;    
    fechaAudiencia:             FechaAudienciaProps;
    solicitarFechaAudiencia:    boolean;
    idUsuarioElaboro:           number;
    observaciones:              boolean;
    asistentes:                 AsistenteProps[],
    notificaciones:             NotificacionesProps[],
    anexos:                     AnexoProps[];
    promociones:                PromocionesProps[];
    usuarioObservaciones:       UsuarioObservacionesProps[];
    fecha?:                     Date;
    fechaInicioAgenda?:         Date;
    fechaFinAgenda?:            Date;
    fechaHoraInicio?:           Date;
}

export interface AudienciaDetalleResponse extends HttpResponse, AudienciaProps{}

export interface GuardarInformacionParams {
    idAudiencia:                string;
    seCelebro:                  boolean;
    idTipoNoCelebracion:        number;
    seDifiere:                  boolean;
    idTipoDiferimiento:         number;
    motivoDiferimiento:         string;            
    convenio:                   boolean;
    idTipoConvenio:             number;
    citaSentencia:              boolean;
    fechaInicio:                string;
    idUsuarioElaboro:           number;
    solicitarFechaAudiencia:    boolean;
}

export interface AsistenteProps{
    id:                     number;
    idTipoParte:            number;
    tipoParte:              string;
    idPersona:              number;
    persona:                string;
    idTipoIdentificacion:   number;
    tipoIdentificacion:     string;
    notificado:             boolean;
    asistio:                boolean;
    cedulaNotificacion:     string;
    razonamiento:           string;
    idTipoPersona:          number;
}

export interface GuardarAsistentesParams {
    idAudiencia:    number;
    asistentes:     AsistenteProps[];
}

export interface GuardarNotificacionesParams {
    idAudiencia:        number;
    notificaciones:     NotificacionesProps[];
}

export interface GuardarAnexosParams {
    idAudiencia:    number;
    anexos:         AnexoProps[];
}

export interface PromocionesProps {
    id:                 number;
    idPromocion:        number;
    idAcuerdo:          number;
    noSeguimiento:      string;
    usuarioAsignado:    string;
    estatus:            string;
    promocion:          string;
    acordar:            boolean;
    fecha?:             Date;
}

export interface GuardarPromocionesParams {
    idAudiencia:    number;
    promociones:    PromocionesProps[];
}

export interface ActualizarEstatusAudienciaParams {
    idAudiencia:    string;
    idEstatus:      number;
}

export interface ActualizarEstatusAudienciaResponse extends HttpResponse {
    asignadoMismoUsuario:   boolean;
    usuarioAsignado:        string;
}

export interface UsuarioObservacionesProps { 
    usuario:        string;
    puesto:         string;
    observacion:    string;
    fecha?:         Date;
}

export interface ActualizarActaAudienciaParams {
    idAudiencia:    string;
    contenido:      string;
    idPlantilla:    number;
    observaciones:  string;
}

export interface ObtenerAgendaAudienciasParams extends PaginacionProps {
    idAutoridad:        number;
    idTipoAudiencia:    number;
    idEstatus:          number;
    fechaAudiencia:     string;
    numeroExpediente:   string;
}

export interface ObtenerAgendaAudienciasResponse {
    records:            AgendaAudienciaProps[];
    currentPageIndex:   number;
    pageCount:          number;
    recordCount:        number;
}

export interface AgendaAudienciaProps {
    idAgenda:           number;
    idExpediente:       number;
    numeroExpediente:   string;
    idEstatus:          number;
    estatus:            string;
    tipoAudiencia:      string;
    sala:               string;
    juez:               string;
    secretario:         string;
    observaciones:      string;
    expediente:         ExpedienteProps;
    fechaAgenda?:       Date,
    fechaInicio?:       Date,
    fechaFin?:          Date,
}

export interface DescargarInformacionParams {
    idAutoridad:        number;
    idTipoAudiencia:    number;
    idEstatus:          number;
    fechaAudiencia:     string;
    numeroExpediente:   string;
}